import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../_redux/homeworks/HomeworksAction";
import * as uiHelpers from "../HomeworkReportUIHelpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useHomeworkReportUIContext } from "../HomeworkReportUIContext";

export function HomeworkReportTable() {
  // Homework Report UI Context
  const homeworkReportUIContext = useHomeworkReportUIContext();
  const homeworkReportUIProps = useMemo(() => {
    return {
      queryParams: homeworkReportUIContext.queryParams,
      setQueryParams: homeworkReportUIContext.setQueryParams
    };
  }, [homeworkReportUIContext]);

  // Getting curret state of Homework Report from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.homeworks }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;

    // Homework Report Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getHomeworkReport(homeworkReportUIProps.queryParams));
    return () => dispatch(actions.cleanHomeworksState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [homeworkReportUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "teacher",
      text: "Öğretmen",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "180px",
      }
    },
    {
      dataField: "section",
      text: "Sınıf",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px",
      }
    },
    {
      dataField: "course",
      text: "Ders",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "250px",
      }
    },
    {
      dataField: "homeworkCount",
      text: "Toplam Ödev Sayısı",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "190px",
      }
    },
    {
      dataField: "evaluatedHomeworkCount",
      text: "Değerlendirilen Ödev Sayısı",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "250px",
      }
    },
    {
      dataField: "unevaluatedHomeworkCount",
      text: "Değerlendirilmeyen Ödev Sayısı",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "280px",
      }
    },
    {
      dataField: "notYetDueHomeworkCount",
      text: "Değerlendirilme Tarihi Gelmeyen Ödev Sayısı",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "375px",
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: homeworkReportUIProps.queryParams.pageSize,
    page: homeworkReportUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                homeworkReportUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}